import React from 'react';
import useAnimatedVisibility from './useAnimatedVisibility';

const AnimatedVisibility = props => {
    const {
            className = '',
            visible,
            children,
            visibleClassName = '',
            hiddenClassName = '',
            showingClassName = '',
            hidingClassName = '',
            showTimeout,
            hideTimeout,
        } = props,
        {mounted, visible: isVisible, showing, hiding, onTransitionEnd} = useAnimatedVisibility({visible, showTimeout, hideTimeout});

    if (!mounted) return null;

    return (
        <div
            className={[className, isVisible ? visibleClassName : hiddenClassName, showing ? showingClassName : '', hiding ? hiddenClassName : ''].join(' ')}
            onTransitionEnd={onTransitionEnd}>
            {children}
        </div>
    );
};

export default AnimatedVisibility;
